import arielPic from "@/public/images/artists/ariel.png";
import { Artist } from "@/types/types";

export const ariel = {
  id: "35",
  name: "Ariel",
  image: arielPic,
  description: `Introducing "Ariel", an R&B sensation. With soulful and velvety vocals, Ariel brings a timeless yet contemporary charm to R&B music. Her voice effortlessly traverses emotional depths, infusing every note with passion and authenticity.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fariel-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["RnB", "Pop", "Dance", "Ballads"],
      secondary: ["Singer"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
